export interface ICard {
  title: string;
  titleIcon: EHeaderIcons;
  content: string[];
}

export enum EHeaderIcons {
  Bank,
  Developer,
  Ensuranse,
  RealEstate,
  Retail,
}
